import React from "react";
import { ExplainerSection, NAVY, CYAN, LIME, INK, LIGHT } from "./ExplainerSection";

const BlocksIllu = () => (
  <svg viewBox="0 0 400 260" className="w-full h-auto" role="img" aria-label="Fünf Services greifen ineinander wie Bausteine">
    <rect width="400" height="260" fill={LIGHT} />
    {/* Shield outline */}
    <path d="M 200 25 l 95 30 v 65 q 0 60 -95 95 q -95 -35 -95 -95 v -65 z" fill="none" stroke={NAVY} strokeWidth="2.5" strokeDasharray="7 5" />
    {/* Blocks */}
    {[
      { x: 148, y: 66, w: 104, label: "FIREWALL", c: NAVY, d: "0s" },
      { x: 148, y: 96, w: 50, label: "AV", c: CYAN, d: "0.5s" },
      { x: 202, y: 96, w: 50, label: "XDR", c: CYAN, d: "1s" },
      { x: 148, y: 126, w: 104, label: "BACKUP", c: NAVY, d: "1.5s" },
      { x: 148, y: 156, w: 104, label: "MAIL & ARCHIV", c: LIME, d: "2s" },
    ].map((b, i) => (
      <g key={i} opacity="0">
        <animate attributeName="opacity" values="0;1;1;1;1;0" dur="6s" begin={b.d} repeatCount="indefinite" />
        <rect x={b.x} y={b.y} width={b.w} height="26" rx="3" fill={b.c} />
        <text x={b.x + b.w / 2} y={b.y + 17} textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="9" fontWeight="bold" fill={b.c === LIME ? INK : "#fff"}>{b.label}</text>
      </g>
    ))}
    <text x="60" y="60" fontFamily="ui-monospace, monospace" fontSize="9" fill={INK}>5 SERVICES</text>
    <text x="290" y="200" fontFamily="ui-monospace, monospace" fontSize="9" fill={NAVY} fontWeight="bold">1 SCHUTZSCHILD</text>
    <text x="200" y="245" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="10" fill={INK} letterSpacing="2">
      JEDER BAUSTEIN VERSTÄRKT DEN NÄCHSTEN
    </text>
  </svg>
);

const OneHandIllu = () => (
  <svg viewBox="0 0 400 260" className="w-full h-auto" role="img" aria-label="Alles aus einer Hand: ein Partner, eine Rechnung">
    <rect width="400" height="260" fill={LIGHT} />
    {/* 5 services converge */}
    {["FIREWALL", "ANTIVIRUS", "XDR", "BACKUP", "EXCHANGE"].map((s, i) => (
      <g key={s}>
        <text x="40" y={50 + i * 34} fontFamily="ui-monospace, monospace" fontSize="9" fill={NAVY}>{s}</text>
        <path d={`M 115 ${46 + i * 34} Q 175 ${46 + i * 34} 205 128`} fill="none" stroke={CYAN} strokeWidth="2" strokeDasharray="5 4">
          <animate attributeName="stroke-dashoffset" values="60;0" dur="2s" begin={`${i * 0.2}s`} repeatCount="indefinite" />
        </path>
      </g>
    ))}
    {/* One document */}
    <rect x="225" y="55" width="130" height="150" rx="4" fill="#fff" stroke={NAVY} strokeWidth="2.5" />
    <rect x="225" y="55" width="130" height="26" rx="4" fill={NAVY} />
    <text x="290" y="72" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="8" fill="#fff" letterSpacing="1">1 RECHNUNG · 1 SLA</text>
    {[0, 1, 2, 3, 4].map((i) => (
      <g key={i}>
        <circle cx="243" cy={98 + i * 18} r="5" fill={LIME} />
        <text x="243" y={101 + i * 18} textAnchor="middle" fontSize="7" fontWeight="bold" fill={INK}>✓</text>
        <rect x="256" y={95 + i * 18} width={80 - i * 6} height="4" fill="#D3DEE6" />
      </g>
    ))}
    <text x="290" y="198" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="10" fontWeight="900" fill={NAVY}>1 ANSPRECHPARTNER</text>
    <text x="200" y="245" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="10" fill={INK} letterSpacing="2">
      KEIN ANBIETER-CHAOS · ALLES AUS EINER HAND
    </text>
  </svg>
);

const SlaIllu = () => (
  <svg viewBox="0 0 400 260" className="w-full h-auto" role="img" aria-label="Garantierte Reaktionszeit unter 40 Minuten">
    <rect width="400" height="260" fill={INK} />
    {/* Ringing phone */}
    <g>
      <rect x="70" y="75" width="60" height="100" rx="10" fill="#fff" stroke={CYAN} strokeWidth="2">
        <animateTransform attributeName="transform" type="rotate" values="-3 100 125;3 100 125;-3 100 125" dur="0.4s" repeatCount="indefinite" />
      </rect>
      {[0, 1].map((i) => (
        <path key={i} d={`M ${140 + i * 12} 95 q ${14 + i * 6} 30 0 60`} fill="none" stroke={LIME} strokeWidth="2.5">
          <animate attributeName="opacity" values="0.2;1;0.2" dur="1s" begin={`${i * 0.3}s`} repeatCount="indefinite" />
        </path>
      ))}
    </g>
    <text x="100" y="205" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="9" fill="#fff" opacity="0.8">STÖRUNG GEMELDET</text>
    {/* Arrow */}
    <path d="M 185 125 h 40" stroke={CYAN} strokeWidth="2.5" strokeDasharray="6 4">
      <animate attributeName="stroke-dashoffset" values="20;0" dur="1s" repeatCount="indefinite" />
    </path>
    <polygon points="228,125 218,119 218,131" fill={CYAN} />
    {/* Stopwatch */}
    <circle cx="300" cy="120" r="52" fill="none" stroke={CYAN} strokeWidth="3" />
    <rect x="293" y="55" width="14" height="9" fill={CYAN} />
    <line x1="300" y1="120" x2="300" y2="85" stroke={LIME} strokeWidth="4" strokeLinecap="round">
      <animateTransform attributeName="transform" type="rotate" values="0 300 120;240 300 120;0 300 120" dur="4s" repeatCount="indefinite" />
    </line>
    <circle cx="300" cy="120" r="5" fill={LIME} />
    <text x="300" y="198" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="16" fontWeight="900" fill={LIME}>{"< 40 MIN"}</text>
    <text x="200" y="245" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="10" fill="#fff" letterSpacing="2">
      REAKTIONSZEIT · VERTRAGLICH ZUGESICHERT
    </text>
  </svg>
);

const CycleIllu = () => (
  <svg viewBox="0 0 400 260" className="w-full h-auto" role="img" aria-label="Kontinuierliches Schwachstellenmanagement als Kreislauf">
    <rect width="400" height="260" fill={INK} />
    {/* Rotating cycle */}
    <g>
      <circle cx="200" cy="120" r="70" fill="none" stroke={CYAN} strokeWidth="2" strokeDasharray="10 8">
        <animateTransform attributeName="transform" type="rotate" from="0 200 120" to="360 200 120" dur="10s" repeatCount="indefinite" />
      </circle>
    </g>
    {/* 4 nodes */}
    {[
      { x: 200, y: 40, label: "SCANNEN", c: CYAN },
      { x: 290, y: 120, label: "BEWERTEN", c: LIME },
      { x: 200, y: 200, label: "PATCHEN", c: CYAN },
      { x: 110, y: 120, label: "REPORTEN", c: LIME },
    ].map((n, i) => (
      <g key={n.label}>
        <circle cx={n.x} cy={n.y} r="26" fill={NAVY} stroke={n.c} strokeWidth="2.5">
          <animate attributeName="stroke-width" values="2.5;5;2.5" dur="4s" begin={`${i}s`} repeatCount="indefinite" />
        </circle>
        <text x={n.x} y={n.y + 3} textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="7.5" fontWeight="bold" fill="#fff">{n.label}</text>
      </g>
    ))}
    {/* Center */}
    <text x="200" y="115" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="9" fill={LIME} fontWeight="bold">24/7</text>
    <text x="200" y="130" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="8" fill="#fff" opacity="0.8">OHNE PAUSE</text>
    <text x="340" y="45" fontFamily="ui-monospace, monospace" fontSize="8" fill={LIME}>INKLUSIVE</text>
    <text x="200" y="245" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="10" fill="#fff" letterSpacing="2">
      KONTINUIERLICHES SCHWACHSTELLENMANAGEMENT
    </text>
  </svg>
);

const ITEMS = [
  { step: "01", illu: BlocksIllu, title: "Fünf Bausteine, ein Schutzschild", desc: "Firewall, Antivirus, XDR, Backup und E-Mail-Archivierung sind aufeinander abgestimmt. Jeder Baustein verstärkt den nächsten – statt fünf Insellösungen bekommen Sie ein System.", testId: "blocks" },
  { step: "02", illu: OneHandIllu, title: "Ein Partner, eine Rechnung", desc: "Schluss mit Anbieter-Chaos: alle Services laufen über einen Vertrag, eine monatliche Rechnung und einen Ansprechpartner, der Ihre Umgebung wirklich kennt.", testId: "onehand" },
  { step: "03", illu: SlaIllu, title: "Im Ernstfall zählt jede Minute", desc: "Vertraglich zugesichert: Wir reagieren in unter 40 Minuten auf Ihre Meldung – 7 Tage die Woche. Bei kritischen XDR-Vorfällen rufen wir Sie aktiv an.", testId: "sla" },
  { step: "04", illu: CycleIllu, title: "Lücken schließen – bevor sie jemand findet", desc: "Kontinuierliches Schwachstellenmanagement ist Teil des Pakets: Wir scannen Ihre IT laufend, bewerten jede Lücke nach CVSS, patchen priorisiert und liefern audit-fähige Reports.", testId: "cycle" },
];

export const MsExplainers = () => (
  <ExplainerSection
    eyebrow="So funktionieren unsere Managed Services"
    titleA="Vier Prinzipien."
    titleB="Einfach erklärt."
    intro="Was bedeutet „Managed“ eigentlich konkret für Sie? Hier sehen Sie visuell, wie unsere Services zusammenspielen – und warum das Ganze mehr ist als die Summe seiner Teile."
    items={ITEMS}
    testId="ms-explainers"
  />
);
